import { Dispatch, SetStateAction } from 'react';
import { ProductDealerPriceAvailability } from 'services/dealerPriceAvailability/types';
import { LocationAddress } from 'services/location/types';
import { Graphics } from 'services/parts-diagram/type';

export interface ListOfArrangementsResponse {
  serialNumber: string;
  productDescription: string;
  lineItems: LineItem[];
}

export interface LineItem {
  partNumber: string;
  name: string;
  quantity: null | string;
  ieSystemControlNumber: null | string;
  disambiguation: boolean;
  mediaNumber: string | null;
  componentId: null | string;
  referenceNumber?: null | string;
  attachmentSerialNumber?: null | string;
  priceAndAvailabilityData?: ProductDealerPriceAvailability;
  imageIdentifiers?: string;
}

export interface SelectedEquipmentResponseType {
  productFamily: string;
  serialNumber: string;
  dealerCode: null | string;
  unvalidatedItemListId: string;
  unvalidatedEquipmentId: string;
  dcn: null | string;
  uniqueIndex: string;
  isCommercialEngine: boolean;
  assetId: null | string;
  imageURL: string;
  isSerialAndModelValid: boolean;
  assetName: string;
  isValidatedAsset: boolean;
  model: string;
  partNumber: string;
  id: string;
  make: string;
}

export interface SystemDataResponseType {
  id: string;
  description: string;
  configurationPartsMediaNumbers: string[];
  components: ComponentsType[];
}

export interface ComponentsType {
  id: string;
  description: string;
  groupParts?: GroupPartsType[];
}

export interface GroupPartsType {
  isTopLevel?: boolean;
  partNumber: string;
  name: string;
  captionName?: string;
  ieSystemControlNumber: string;
  configurationPartsMediaNumber?: string;
}

export interface GroupItemType {
  partNumber: string;
  name: string;
  ieSystemControlNumber: string;
  componentId: string;
}

export interface PartDetailsAndSchematicResponse {
  ieControlNumber: string;
  mediaNumber: string;
  captionName: string;
  groupPart: { partNumber: string; name: string };
  currency: string;
  lineItems: LineItem[];
  graphics?: Graphics[];
  title?: string;
  graphicSVG?: string;
}

export interface ContactDealerData {
  locale: string;
  dealerData?: {
    address?: LocationAddress;
  };
}

export enum CATEGORY_TYPES {
  PARTSCARDS = 'PartCards',
  LISTOFARRANGEMENTS = 'ListOfArrangements',
  PARTSDETAILS = 'PartsDetails',
  LOADER = 'Loader'
}

export interface Component {
  componentId: string;
}

export interface PartWhereUsed {
  ieSystemControlNumber: string;
  systemId: string;
  components: Component[];
}

export interface SearchParams {
  componentId: string;
  ieSystemControlNumber: string;
  systemId: string;
}

export interface MenuIndex {
  indexArr: number[];
  data: {
    id?: string;
    systemId: string;
    componentId: string;
    partNumber: string;
    ieSystemControlNumber: string;
  };
}

export type PartType = 'system' | 'component' | 'part';

export interface PartItem {
  partNumber?: string;
  ieSystemControlNumber?: string;
  partType?: PartType;
  sysId?: string;
  compId?: string;
}

export type DealerData = {
  address?: LocationAddress;
  dealerName?: string;
  id?: number;
};

export type AnalyticsCommonInformation = {
  dealerData?: DealerData;
  currency?: string;
  model?: string;
  locale?: string;
};

export interface PartsOverviewCardProps {
  currency: string;
  partItem: LineItem;
  index: number;
  handlePartView: (lineItem: LineItem) => void;
  onHover: (referenceNumber: string | null) => void;
  shouldHideBtn?: boolean;
  lastItem: number;
  handleOpen: (
    partNumber: string,
    price: ProductDealerPriceAvailability
  ) => Promise<void>;
  openQuickViewDrawer: Dispatch<SetStateAction<boolean>>;
  fromProductPage?: boolean;
}

export interface PartsTableProps {
  lineItem: LineItem;
  index: number;
  currency: string;
  shouldHideBtn?: boolean;
  handlePartView: () => void;
  handleOpen: (partNumber: string, price: unknown) => Promise<void>;
  setDrawerActive: (drawerActive: boolean) => void;
  fromProductPage?: boolean;
}
